<template>
  <modal name="item-one-select-modal" class="offline-review-modal"
         :width="'80%'"
         :height="'80%'"
         @before-close="handlerBeforeClose"
         @before-open="handlerBeforeOpen"
         @opened="handlerOpened"
  >
    <div class="list-content pa15">
      <board-list-component
          class="list-content"
          :boardType=boardType
          :userKey="userKey"
          :ssamsKey="ssamsKey"
      ></board-list-component>
    </div>
  </modal>
</template>

<script>
import BoardListComponent from "@/components/board/BoardListComponent";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
export default {
    name: 'ItemOneSelectModal',
    props: {},
    mixins: [],
    components: {BoardListComponent},
    computed: {},
    provide() {
        return {
            selectModalData: this.selectData,
        }
    },
    data() {
        return {
            boardType: '',
            defaultFilter: {},
            userKey: "",
            ssamsKey: Number(this.$route.params.s_idx) ?? 0,

          emitName: 'setSelectOneModalData',
        }
    },
    mounted() {

    },
    methods: {
        handlerBeforeOpen(event) {
            if (!util.isEmpty(event.params) && !util.isEmpty(event.params.boardType)) {
                console.log(event.params.boardType);
                this.boardType = event.params.boardType;
            }
          if (!util.isEmpty(event.params) && !util.isEmpty(event.params.emitName)) {
            this.emitName = event.params.emitName;
          }else {
            this.emitName = 'setSelectOneModalData';
          }
          EventBus.$on("selectModalData",this.selectData);
        },
        handlerOpened() {

        },
        handlerBeforeClose() {
            this.boardType = '';
            this.emitName = 'setSelectOneModalData'
            EventBus.$off("selectModalData");
        },
        modalClose() {
            this.$modal.hide('item-one-select-modal');
        },

        selectData(fixData) {
          EventBus.$emit(this.emitName, fixData);
            this.modalClose();
        },
    }
}
</script>
